import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./sidebar.css";
import "./flex_panel.css";
import "./canyon_tour.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
